import type { Color, Move, PieceSymbol } from 'chess.js';

const VALOR: Record<PieceSymbol, number> = {
  p: 1,
  n: 3,
  b: 3,
  r: 5,
  q: 9,
  k: 0
};

const ORDEM: PieceSymbol[] = ['q', 'r', 'b', 'n', 'p'];

export interface MaterialCapturado {
  /** Peças pretas capturadas pelas brancas (mortas do lado preto). */
  porBrancas: PieceSymbol[];
  /** Peças brancas capturadas pelas pretas (mortas do lado branco). */
  porPretas: PieceSymbol[];
  /** Vantagem em peões para as brancas (positivo = brancas à frente). */
  vantagemBrancas: number;
}

function ordenar(pecas: PieceSymbol[]): PieceSymbol[] {
  return [...pecas].sort((a, b) => ORDEM.indexOf(a) - ORDEM.indexOf(b) || 0);
}

/** Deriva capturas do histórico verbose do chess.js (inclui en passant). */
export function materialCapturado(historico: Move[]): MaterialCapturado {
  const porBrancas: PieceSymbol[] = [];
  const porPretas: PieceSymbol[] = [];
  for (const lance of historico) {
    if (!lance.captured) continue;
    if (lance.color === 'w') porBrancas.push(lance.captured);
    else porPretas.push(lance.captured);
  }
  const valor = (lista: PieceSymbol[]) => lista.reduce((acc, p) => acc + (VALOR[p] ?? 0), 0);
  return {
    porBrancas: ordenar(porBrancas),
    porPretas: ordenar(porPretas),
    vantagemBrancas: valor(porBrancas) - valor(porPretas)
  };
}

/** Peças capturadas pelo lado `cor` (as que ele “matou”). */
export function capturasDoLado(material: MaterialCapturado, cor: Color): PieceSymbol[] {
  return cor === 'w' ? material.porBrancas : material.porPretas;
}

/** Vantagem de material na perspectiva de `cor` (positivo = esse lado está na frente). */
export function vantagemDoLado(material: MaterialCapturado, cor: Color): number {
  return cor === 'w' ? material.vantagemBrancas : -material.vantagemBrancas;
}
